import { get, patch } from '@/helpers/httpHandler';

export default {
  getSmartHomeDevices({ commit }, { params } = {}) {
    return get(`/smarthome-devices`, params).then(response => {
      commit('setSmartHomeDevices', response.data.data);

      return response;
    });
  },

  getSmartHomeDevice: ({ commit }, { id, params } = {}) => {
    return get(`/smarthome-devices/${id}`, params).then(response => {
      commit('updateSmartHomeDevice', response.data.data);

      return response;
    });
  },

  updateSmartHomeDevice: ({ commit }, { id, smartHomeDevice }) => {
    return patch(`/smarthome-devices/${id}`, smartHomeDevice).then(response => {
      commit('updateSmartHomeDevice', response.data.data);

      return response;
    });
  },

  setApartmentSmartHomeDevice: ({ commit }, payload) => {
    commit('setApartmentSmartHomeDevice', payload);
  },

  getSmartHomeDeviceStatuses({ commit }, { params } = {}) {
    return get(`/smarthome-devices/statuses`, params).then(response => {
      commit('setSmartHomeDeviceStatuses', response.data.data);

      return response;
    });
  },

  getBuildings(_, params) {
    return get(`/smarthome-devices/filters/buildings`, params);
  },

  getApartments(_, params) {
    return get(`/smarthome-devices/filters/apartments`, params);
  },


  getSmartHomeDevicesAppID({ commit }) {
    return get(`/smarthome-devices/app-id`).then(response => {
      return response.data;
    });
  },
};
